package com.exura.components.snackbar

import kotlinx.coroutines.channels.Channel
import kotlinx.datetime.Clock

internal data class SnackbarMessage(
    val message: String,
    val timestampMillis: Long = Clock.System.now().toEpochMilliseconds(),
)

interface SnackbarController {
    fun show(message: String)
    suspend fun showAwaitable(message: String)
}

internal class ChannelSnackbarController(
    private val channel: Channel<SnackbarMessage>
) : SnackbarController {
    override fun show(message: String) {
        channel.trySend(SnackbarMessage(message))
    }

    override suspend fun showAwaitable(message: String) {
        channel.send(SnackbarMessage(message))
    }
}
